'use strict';

module.exports = Odigeo.Widget.extend({
    subscribers: null,
    modelClass: require('../modules/models/accommodation_filters_manager'),
    viewClass: require('../modules/views/accommodation_filters_manager'),

    reset: function() {
        this.model.requestResetAction.apply(this.model, arguments);
    },

    resetTagFilter: function() {
        this.view.cleanFilterTag.apply(this.view, arguments);
    },

    update: function() {
        this.model.update.apply(this.model, arguments);
    },

    refreshFilters: function() {
        this.model.refreshFilters.apply(this.model, arguments);
    },

    getLabels: function() {
        this.model.requestFilterAction.apply(this.model, arguments);
    },

    changeFilter: function() {
        this.model.onFilterHasChanged.apply(this.model, arguments);
    },

    showContainer: function() {
        this.view.showContainer();
    },

    hideContainer: function() {
        this.view.hideContainer();
    },
    hasSomeFilterActive: function(callback = Odigeo._.noop) {
        const {accommodationSearchResultsMetadata} = this.model.metadata;
        return callback(accommodationSearchResultsMetadata.numResults !== accommodationSearchResultsMetadata.numFilteredResults);
    },
});
